function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import React from 'react';
import { PremiumLocaleContext } from '../../providers/PremiumLocaleProvider/PremiumLocaleProvider';
import { formattingOptions } from './makeDateFormatter';
export var DateTimeFormatter = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(DateTimeFormatter, _React$Component);
  function DateTimeFormatter() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _defineProperty(_assertThisInitialized(_this), "format", function (makeDateFormatter) {
      return function (date) {
        return makeDateFormatter(_this.props.dateFormat).format(new Date(date));
      };
    });
    return _this;
  }
  var _proto = DateTimeFormatter.prototype;
  _proto.render = function render() {
    var _this2 = this;
    return /*#__PURE__*/React.createElement(PremiumLocaleContext.Consumer, null, function (_ref) {
      var makeDateFormatter = _ref.makeDateFormatter;
      return _this2.props.render(_this2.format(makeDateFormatter));
    });
  };
  return DateTimeFormatter;
}(React.Component);